import { render } from "./Usuarios.vue?vue&type=template&id=6de66e0a&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"comensales\":\"data\",\"sendInfo\":\"options\",\"sendNuevo\":\"options\",\"guardar\":\"options\",\"nuevo_guardar\":\"options\"}"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"

import "./Usuarios.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script